import { API_BASE_ADMIN, STORAGE_KEYS, isCapacitorRuntime } from "../config/vars";

function getStoredAccessToken() {
    if (!isCapacitorRuntime()) return null;
    try {
        return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    } catch (_) {
        return null;
    }
}

function _getPath(input) {
    if (typeof input !== "string") return "";
    try {
        return new URL(input, window.location.origin).pathname;
    } catch (_) {
        return input;
    }
}

function shouldSkipRefresh(input) {
    const path = _getPath(input);
    if (!path.includes("/login/")) return false;

    // Avoid refresh loops or unnecessary refresh attempts.
    if (path.endsWith("/login/refresh")) return true;
    if (path.endsWith("/login/logout")) return true;

    // Skip refresh for actual login endpoints (but NOT /login/me).
    return /\/login\/(admin|operator|client)(\/verify-code)?$/.test(path);
}

export async function apiFetch(input, init = {}, options = {}) {
    const { retryOn401 = true } = options;

    const bearer = getStoredAccessToken();
    const headers = new Headers(init?.headers || undefined);
    if (bearer) {
        headers.set("Authorization", `Bearer ${bearer}`);
    }

    const res = await fetch(input, {
        ...init,
        headers,
        credentials: "include",
    });

    if (bearer) {
        return res;
    }

    if (!retryOn401 || res.status !== 401 || shouldSkipRefresh(input) || !API_BASE_ADMIN) {
        return res;
    }

    const refreshRes = await fetch(`${API_BASE_ADMIN}/login/refresh`, {
        method: "POST",
        credentials: "include",
    });

    if (!refreshRes.ok) {
        return res;
    }

    return fetch(input, {
        ...init,
        credentials: "include",
    });
}
